<template>
  <div class="footer-wrapper">
    

     <div class="back-btn-container">
      <!-- Previous Button -->
      <button class="back-btn" @click="goBack">
        <i class="bi bi-arrow-left me-2"></i>
        Back
      </button>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();

const goBack = () => {
  router.back(); // Navigates to the previous page in browser history
};
</script>

<style scoped>
.footer-wrapper {
  background-color: transparent;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.back-btn-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 1rem 2rem;
}

.back-btn {
  background-color: #2c4fa1;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 30px;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s ease;
}

.back-btn:hover {
  background-color: #1f3978;
  cursor: pointer;
}
</style>
